export default __webpack_public_path__ + "static/media/img_card_4.dc53a57f.svg";